import React from 'react'
import _ from 'lodash';
import './header.css';
import logo from '../assets/logo.svg';
import circleLogo from '../assets/circle-logo.svg';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showJoin: false
    };
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    const scrollTop = _.get(event, 'srcElement.scrollingElement.scrollTop');
    if (!this.state.showJoin && scrollTop > 20) {
      this.setState({ showJoin: true });
    } else if (this.state.showJoin && scrollTop < 20) {
      this.setState({ showJoin: false });
    }
  }

  render() {
    const { showJoin } = this.state;
    const hideTransform = `scale(0)`;
    const showTransform = `scale(1)`;
    return (
      <nav className="header">
        <div className="logo-container">
          <div className="logo" style={{ transform: showJoin ? hideTransform : showTransform, position: 'fixed' }} >
            <img src={ logo } alt=""/>
          </div>
          <div className="logo" style={{ transform: showJoin ? showTransform : hideTransform }} >
            <img src={ circleLogo } alt=""/>
          </div>
          </div>
        <div style={{ opacity: showJoin ? 1 : 0 }} className="join-now-btn">
          { showJoin && <a className="join-now-btn" href="https://join.whoop.com/?utm_source=soberoctober">JOIN NOW</a> }
        </div>
      </nav>
    );
  }
};

export default Header;
